import { Component, OnInit, ViewChild, Renderer2, ElementRef, NgZone, HostListener } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';


@Component({
  selector: 'app-sign',
  templateUrl: './sign.page.html',
  styleUrls: ['./sign.page.scss'],
})
export class SignPage implements OnInit {

  // @ViewChild(  "signCanvas", {static: true} ) canvasMobile: any
  @ViewChild("signCanvasDesktop", {static: true} ) canvas: ElementRef<HTMLCanvasElement>

  public isMouseDown: boolean = false
  public hasMouse: boolean = this.platform.is("desktop") || this.platform.is("mobileweb")

  private lastX: number;
  private lastY: number;

  private startBounding: {height: number, width: number} = {height: 0, width: 0}

  constructor(
    private renderer: Renderer2,
    private modalCtrl: ModalController,
    public platform: Platform,
    public darkmode: DarkmodeService,
    private ngZone: NgZone
    ) {}

  async ngOnInit() {

  }

  async ngAfterViewInit(){    
    this.setCanvasSize()
    await this.iosWebkitBug()
  }

  private setCanvasSize(){
    this.ngZone.run(() => {
      const bounding: {height: number, width: number} = this.canvas.nativeElement.getBoundingClientRect()
      this.startBounding = bounding
      this.renderer.setAttribute(this.canvas.nativeElement, "width", bounding.width + "")
      this.renderer.setAttribute(this.canvas.nativeElement, "height", bounding.height + "")
    })
  }

  public async complete(){
    const canvas = this.canvas.nativeElement;
    const context = canvas.getContext('2d');
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);


    const bounds = this.getContentBounds(imageData, canvas.width, canvas.height);
    
    // Wenn keine Zeichnung vorhanden ist
    if (!bounds) {
      await this.modalCtrl.dismiss(canvas.toDataURL());
      return;
    }
    
    // Erstelle ein neues Canvas mit den Maßen des gezeichneten Inhalts
    const trimmedCanvas: HTMLCanvasElement = document.createElement('canvas');
    trimmedCanvas.width = bounds.width;
    trimmedCanvas.height = bounds.height;
    
    // Kopiere nur den gezeichneten Bereich
    const trimmedContext = trimmedCanvas.getContext('2d');
    trimmedContext.drawImage(
      canvas,
      bounds.left, bounds.top, bounds.width, bounds.height,
      0, 0, bounds.width, bounds.height
    );
    
    await this.modalCtrl.dismiss(trimmedCanvas.toDataURL())
  }

  private getContentBounds(imageData: ImageData, width: number, height: number) {
    const data = imageData.data;
    let minX = width;
    let minY = height;
    let maxX = 0;
    let maxY = 0;
    let found = false;
    
    // Durchsuche alle Pixel
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        // Prüfe den Alpha-Kanal jedes Pixels
        const alpha = data[((y * width + x) * 4) + 3];
        if (alpha > 0) { // Nicht-transparenter Pixel gefunden
          found = true;
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }
    }
    
    if (!found) return null; // Keine Zeichnung vorhanden
    
    // Füge etwas Padding hinzu, damit die Zeichnung nicht am Rand klebt
    const padding = 5;
    minX = Math.max(0, minX - padding);
    minY = Math.max(0, minY - padding);
    maxX = Math.min(width - 1, maxX + padding);
    maxY = Math.min(height - 1, maxY + padding);
    
    return {
      left: minX,
      top: minY,
      width: maxX - minX + 1,
      height: maxY - minY + 1
    };
  }

  public handleStart(event: TouchEvent | MouseEvent){ 
    
    const currentBounding: {height: number, width: number} = this.canvas.nativeElement.getBoundingClientRect()
    if(this.startBounding.height !== currentBounding.height || this.startBounding.width !== currentBounding.width) this.setCanvasSize()

    const pos: {y: number, x: number} = this.getCanvasRelative(event);

    this.lastX = pos.x
    this.lastY = pos.y
  } 
 
  public handleMove(event: TouchEvent | MouseEvent){

    event.preventDefault()
    if((this.hasMouse && event.type != "touchmove") && !this.isMouseDown) return
    const pos: {y: number, x: number} = this.getCanvasRelative(event);
    
    let context = this.canvas.nativeElement.getContext("2d")

    context.beginPath() 
    context.lineJoin = "round" 
    context.moveTo(this.lastX, this.lastY);
    context.lineTo(pos.x, pos.y);
    context.closePath()
    context.strokeStyle = "#000000"
    // context.strokeStyle = this.darkmode.isDarkModeValue ? "#ffffff" : "#303750"
    context.lineWidth = 10
    context.stroke()

    this.lastX = pos.x;
    this.lastY = pos.y;
  }


  private getCanvasRelative(e: any): {y: number, x: number}{
    var canvas = e.target,
    bx = canvas.getBoundingClientRect();
    return {
        x: (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - bx.left,
        y: (e.changedTouches ? e.changedTouches[0].clientY : e.clientY) - bx.top,
        // bx: bx
    };
  }




  public clearCanvas(){
    let context = this.canvas.nativeElement.getContext('2d');
    context.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
  }

  /**
   * @link https://github.com/ionic-team/capacitor/issues/1581
   */
  private async iosWebkitBug(){
    let context = this.canvas.nativeElement.getContext("2d")
    context.beginPath() 
    context.moveTo(0,0)
    context.lineTo(0,0)
    context.closePath()
    context.stroke()
  }

  private rotateCanvas90(canvas) {
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = canvas.height;
    tempCanvas.height = canvas.width;
  
    const tempCtx = tempCanvas.getContext("2d");
    tempCtx.translate(canvas.height, 0);
    tempCtx.rotate(Math.PI / 2);
    tempCtx.drawImage(canvas, 0, 0);
  
    return tempCanvas;
  }

}
